<div class="_outer">
  <div class="_inner"
    [dfs]="'br:2px'"
    >
    @switch (isBusy) {
      @case (true) {
        <icms-loader></icms-loader>
      }
      @default {
        <icms-icon class="_icon"
        [icon]="icon"></icms-icon>
      }
    }
  </div>
</div>
<ng-content></ng-content>